module.exports = __webpack_public_path__ + "img/202210.8b2d919a.png";